import { TransactionCategory, TransactionType, Transaction } from './transaction';
import { AnalysisCalendar } from './analysis';

export type CashFlowNature = 'incomes' | 'resources' | 'expenses' | 'fixedCharges' | 'loans' | 'unknown';

export interface CashFlowCalendarEntry {
  amount: number;
  totalRejectedAmount: number;
}

export interface CashFlowCalendar {
  [key: string]: CashFlowCalendarEntry | undefined;
}

export type LabelStrategy = 'default' | 'onlyCategory' | 'categoryAndType' | 'labelRoot';

export interface GroupedCashFlow {
  index: number;
  id?: string;
  category: TransactionCategory;
  label?: string | null;
  calendar: CashFlowCalendar;
  total: number;
  transactions?: Transaction[];
  type?: TransactionType;
  labelRoot?: string;
  labelStrategy?: LabelStrategy;
  isSummed?: boolean;
}

export interface CashFlowCollection {
  category: TransactionCategory;
  cashFlows: GroupedCashFlow[];
}

export interface CashFlowsByNature {
  cashFlows: Array<GroupedCashFlow | CashFlowCollection>;
  total: number;
}

export interface CashFlowsByNatureWithoutCollection extends Exclude<CashFlowsByNature, 'cashFlows'> {
  cashFlows: GroupedCashFlow[];
}

export interface GroupedCashFlows {
  calendar: Array<AnalysisCalendar & { date: Date }>;
  resources: CashFlowsByNature;
  incomes: CashFlowsByNature;
  fixedCharges: CashFlowsByNature;
  expenses: CashFlowsByNature;
  loans: CashFlowsByNatureWithoutCollection;
}

export enum AutocompleteInputType {
  AUTOCOMPLETE,
  SELECT,
}
